module.exports = __webpack_public_path__ + "img/sem-imagem.e6b5c109.jpg";